import { render, staticRenderFns } from "./ClaimPendingTable.vue?vue&type=template&id=02e59cc5"
import script from "./ClaimPendingTable.vue?vue&type=script&lang=js"
export * from "./ClaimPendingTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports